import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, Select } from 'antd';
import classNames from 'classnames/bind';
import Enums from 'utils/EnumsManager';
import { setRuleValue, fetchCriteriaFields, resetSelections } from '../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);
const { PhantomId } = Enums;

const FormItem = Form.Item;
const { Option } = Select;

const defaultProps = {
  ruleName: '',
  ruleDescription: '',
  ruleWhen: '',
};
const propTypes = {
  ruleName: PropTypes.string,
  ruleDescription: PropTypes.string,
  ruleWhen: PropTypes.string,
  setRuleValue: PropTypes.func.isRequired
};

const RuleSetup = ({
  workFlowId,
  form,
  ruleFormRef,
  metaContext
}) => {
  const { getFieldDecorator, validateFieldsAndScroll } = form;
  const requiredError = <FormattedMessage id="global.errors.inputRequired" />;

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    ruleFormRef && ruleFormRef(validateFieldsAndScroll);
  }, [form]);

  return (
    <Form>
      <Row gutter={12}>
        <Col span={3} className={classNames(cx('workFlow-form-label'), 'text-right')}>
          <FormattedMessage id="page.WorkFlow.workFlowName">
            {text => <span className="required">{text}</span>}
          </FormattedMessage>
        </Col>
        <Col span={6}>
          <FormItem>
            {getFieldDecorator('ruleName', {
              rules: [{ required: true, message: requiredError }],
            })(<Input />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={3} className={classNames(cx('workFlow-form-label'), 'text-right')}>
          <FormattedMessage id="page.WorkFlow.description" />
        </Col>
        <Col span={21}>
          <FormItem>
            {getFieldDecorator('ruleDescription')(<Input />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={3} className={classNames(cx('workFlow-form-label'), 'text-right')}>
          <FormattedMessage id="page.WorkFlow.when" />
        </Col>
        <Col span={21}>
          <FormItem>
            {getFieldDecorator('ruleWhen', {
              rules: [{ required: true, message: requiredError }]
              })(
                <Select disabled={workFlowId !== PhantomId}>
                  {metaContext.map(context => (
                    <Option
                      key={context.code}
                      id={context.code}
                    >
                      {context.display_name}
                    </Option>
                  ))}
                </Select>
              )}
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = ({ global, setup }) => ({
  lang: global.language,
  ruleName: setup.workFlow.workFlowRule.ruleName,
  ruleDescription: setup.workFlow.workFlowRule.ruleDescription,
  ruleWhen: setup.workFlow.workFlowRule.ruleWhen,
  metaContext: setup.workFlow.metaData.ruleMetaData.context
});

const mapDispatchToProps = {
  setRuleValue,
  fetchCriteriaFields,
  resetSelections
};

const formCreate = Form.create({
  onValuesChange(props, changedValues) {
    const { setRuleValue, fetchCriteriaFields, resetSelections } = props;
    Object.keys(changedValues).forEach(key => {
      const field = changedValues[key];
      setRuleValue(key, field);
      if (key === 'ruleWhen') {
        // fectch the fields when the context change
        resetSelections();
        fetchCriteriaFields(field);
      }
    });
  },
  mapPropsToFields(props) {
    return {
      ruleName: Form.createFormField({
        ...props.ruleName,
        value: props.ruleName
      }),
      ruleDescription: Form.createFormField({
        ...props.ruleDescription,
        value: props.ruleDescription
      }),
      ruleWhen: Form.createFormField({
        ...props.ruleWhen,
        value: props.ruleWhen
      }),
    };
  }
});

const Enhancer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  formCreate
);

RuleSetup.propTypes = propTypes;
RuleSetup.defaultProps = defaultProps;

export default Enhancer(RuleSetup);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/RuleSetup.jsx